import React from 'react';

interface FooterLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

const FooterLogo: React.FC<FooterLogoProps> = ({
  width = 78.95,
  height = 79,
  className = ''
}) => {
  return (
    <div 
      className={`footer-logo ${className}`}
      style={{ 
        width: `${width}px`, 
        height: `${height}px`,
        position: 'relative',
        opacity: 0.6
      }}
    >
      {/* Footer Logo SVG - Exact match from Figma design */}
      <svg 
        width={width} 
        height={height} 
        viewBox="0 0 78.95 79" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Main green background */}
        <rect x="0" y="0" width="78.95" height="79" fill="#289B48"/>
        
        {/* Orange accent rectangle */}
        <rect x="61.56" y="61.53" width="17.39" height="17.46" fill="#EC7D3F"/>
      </svg>
    </div>
  );
};

export default FooterLogo;
